import { localeBase, languages } from './locale.base'

export const locale = {
  ...localeBase,
  defaultLanguage: languages.german,
}